(function ($, window, document, PageLoadedQueue) {
    /**
     * Move the modals so that the z-index can work correctly again
     */
    window.PageLoadedQueue.addFunction(function () {
        const modalElements = document.querySelectorAll('.modal');

        modalElements.forEach(function (modal) {
            document.body.appendChild(modal);
        });
    });
})(jQuery, window, document, window.PageLoadedQueue);
